<template>
  <div class="dialogComponentBox">
    <div class="mask" @click.stop="$emit('closeDialog')"></div>
    <div class="dialogBox">
      <div class="title">
        <span v-if="dialogsStatus==='new'">新增員工</span>
        <span v-if="dialogsStatus==='edit'">編輯員工</span>
      </div>
      <div class="form">
        <div class="row">
          <div class="item" style="width: 100%">
            <div class="label">
              用戶ID
            </div>
            <div class="input">
              <el-input
                :disabled="dialogsStatus==='edit'"
                class="idBox"
                placeholder=""
                v-model="currentUserInfo.memberId"
                clearable>
              </el-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <div class="label">
              員工姓名
            </div>
            <div class="input">
              <el-input
                class="idBox"
                placeholder=""
                v-model="currentUserInfo.userName"
                clearable>
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="label">
              員工性別
            </div>
            <div class="input">
              <el-radio v-model="currentUserInfo.userSex" label="M">男</el-radio>
              <el-radio v-model="currentUserInfo.userSex" label="F">女</el-radio>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="item" style="width: 100%">
            <div class="label">
              職工編號
            </div>
            <div class="input">
              <el-input
                class="idBox"
                placeholder=""
                v-model="currentUserInfo.userWorkCardid"
                clearable>
              </el-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="item" style="width: 100%">
            <div class="label">
              香港身份證
            </div>
            <div class="input">
              <el-input
                class="idBox"
                placeholder=""
                v-model="currentUserInfo.userCardid"
                clearable>
              </el-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <div class="label">
              合約編碼
            </div>
            <div class="input">
              <el-input
                class="idBox"
                placeholder=""
                v-model="currentUserInfo.contractsCode"
                clearable>
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="label">
              合約有效期至
            </div>
            <div class="input">
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="currentUserInfo.contractsExpirationDate"
                type="date"
                placeholder="選擇日期">
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="btnGroup">
        <div class="confirmBtn" @click.stop="$emit('confirmEvent',currentUserInfo)">
          <template v-if="dialogsStatus==='new'">
            確認新建
          </template>
          <template v-if="dialogsStatus==='edit'">
            保存
          </template>
        </div>
        <div class="cancelBtn" @click.stop="$emit('closeDialog')">
          取消
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data()
  {
    return {
      // memberId: "",
      // userName: "",
      // userSex: "",
      // userWorkCardid: "",
      // userCardid: "",
      // contractsCode: "",
      // contractsExpirationDate: "",
      //當前編輯用戶
      currentUserInfo: {},
    }
  },
  props: {
    userInfo: {
      type: Object,
      default()
      {
        return {}
      }
    },
    dialogsStatus: {
      type: String,
      default: "new"
    }
  },
  created()
  {
    if(Object.keys(this.userInfo).length > 0)
    {
      this.currentUserInfo = {...this.userInfo}
    }
  }
}

</script>
<style scoped lang="less">
.dialogComponentBox {
  .mask {
    z-index: 10;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: black;
    opacity: .3;
  }

  .dialogBox {
    padding: 20px;
    z-index: 100;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -60%);
    width: 600px;
    background-color: #ffffff;
    box-shadow: 0 4px 5px 0 rgba(115, 115, 115, 0.24);
    border-radius: 12px;

    .title {
      span {
        display: inline-block;
        border-left: solid 3px #1657da;
        padding: 0 .2rem;
        font-weight: normal;
        font-stretch: normal;
        color: #1b1b1d;
      }
    }

    .row {
      margin-top: .2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item {
        width: 50%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .label {
          width: 80px;
          text-align: center;
        }

        .input {
          flex: 1 1;
          margin-right: .1rem;

          /deep/ input {
            height: 35px;
          }
        }
      }
    }

    .btnGroup {
      margin-top: .3rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .confirmBtn, .cancelBtn {
        cursor: pointer;
        background-color: #1657da;
        width: 100px;
        border-radius: 5px;
        color: white;
        padding: .1rem .2rem;
        text-align: center;
        margin-right: .2rem;
      }

      .cancelBtn {
        background-color: #e0e2e8;
        color: #757b89;
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personnel_manage/dialogs.vue